// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"10c311e56c9064d7c9b8","297":"d9a2ce556ec6ed7c251a","643":"660cd8967f99afbf056e"}[chunkId] + ".js";
};